import React from 'react'
import { integrationSteps } from '../../content/csp'

const IntegrationSteps = () => {
  return (
    <section className="csp-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <span className="csp-kicker">What happens</span>
            <h2 className="csp-title">
              From a first conversation to results you can use.
            </h2>
            <p className="csp-lead">
              Four steps. You can stop after the first one, and you administer
              everything that follows it.
            </p>
          </div>
        </div>
        <ol className="csp-steps">
          {integrationSteps.map((step, index) => (
            <li className="csp-step" key={step.title}>
              <span className="csp-step-number">{index + 1}</span>
              <div>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}

export default IntegrationSteps
